import { Dialog } from "@mui/material";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import Input from "../form/Input";
import { Button } from "../ui";

const EditLeaveTypeModal = ({
  editData,
  isOpen,
  onClose,
  handleUpdateLeaveType,
}) => {
  const { control, register, handleSubmit, setValue } = useForm();

  useEffect(() => {
    setValue("leave_head_name", editData.leave_head_name);
    setValue("is_document_required", editData.is_document_required);
    setValue("leave_head_id", editData.leave_head_id);
  }, [editData]);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="p-5">
        <h1 className="text-xl font-bold mb-4">Edit leave type</h1>
        <form onSubmit={handleSubmit(handleUpdateLeaveType)}>
          <label htmlFor="" className="mb-2 block">
            Leave Type
          </label>
          <Input
            control={control}
            rules={{
              required: "Leave type is required",
            }}
            label="Leave type"
            name="leave_head_name"
            placeholder="Enter leave type"
          />

          <div className="flex items-center mt-4">
            <input
              id="is_document_required"
              type="checkbox"
              {...register("is_document_required")}
              className="mr-2"
            />
            <label htmlFor="is_document_required">Is document required?</label>
          </div>

          <Button type="submit" className="block mt-4 mx-auto">
            Update
          </Button>
        </form>
      </div>
    </Dialog>
  );
};

export default EditLeaveTypeModal;
